var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M4 13.72L9.926 19 20 4","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

TickInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TickInline;

TickInline.default = TickInline;
